import React from 'react';
import { ProductCard } from '../ProductCard';
import { CardInfo } from './partials';
export var ProductInfo = function ProductInfo(_ref) {
  var entity = _ref.entity;
  return React.createElement(CardInfo, {
    padding: "15px 12px"
  }, React.createElement(ProductCard, {
    entity: entity,
    withLink: true
  }));
};